import { useLocation, useNavigate } from "react-router-dom";

export default function useQuery() {
  return new URLSearchParams(useLocation().search);
}

/**
 * 
 * @param {URLSearchParams} query 
 * @returns Array<Object>
 * @description creates a array with object that have a key and a value
 */
const map = (query = new URLSearchParams('')) => {
  const all = [];
  for (const k of query.keys()) {
    all.push({ key: k, val: query.get(k) })
  }
  return all;
};

/**
 * 
 * @param {Array} all 
 * @returns String
 * @description format query params as a string
 */
const printQuery = (all = []) => {
  const str = all.map((i) => `${i.key}=${i.val}`).join('&');
  return `?${str}`;
};

export function useQueryParams() {
  const { search } = useLocation();
  const goTo = useNavigate();
  const query = new URLSearchParams(search);

  /**
   * 
   * @param {String} key 
   * @param {String} val 
   * @description pushes to the same url, with new value of the key, which is added or updated
   */
  const push = (key = '', val = '') => {
    const all = map(query).filter((item) => item.key !== key);
    all.push({ key, val });
    goTo(printQuery(all));
  };

  /**
   * 
   * @param {String} key 
   * @description removes key from query params, and navigates to same url, with filtered keys
   */
  const remove = (key) => {
    const all = map(query).filter((item) => item.key !== key);
    goTo(printQuery(all));
  };

  return {
    query,
    push,
    remove,
  };
}

